import React from 'react';
import {
  Button, Checkbox, DatePicker, Toast,
} from 'antd-mobile';
import { format } from 'date-fns';
import classNames from 'classnames';

import styles from './detail.module.less';
import CarouselComponent from './components/carousel'; // banner组件
import MainInfoComponent from './components/mainInfo'; // 主要信息组件
import DescHtml from './components/descHtml'; // 富文本产品详情组件
import BuyButton from './components/buyButton'; // 页脚购买固定组件
// import WXShare from '../../components/WxShare'

import Activity from '../activity'; // 营销活动页面

import tools from '../../utils/tools';
import {
  getProductDetails, getFormInfo, saveFormInfo, getEffectiveActivities,
} from '../../service/chat-service';
import downImage from '../../public/images/down-form.png';

export default class ProductDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailObj: {
        productImg: [
        // banner 部分
        ],
        labels: [], // tag标签
      },
      formData: [], // 自定义表单数据
      isActive: false, // 是否存在活动
      forwardId: null,
    };
  }

  componentDidMount() {
    window.document.title = '商品详情';
    this.detailProductData();
    this.loadFormData();
    this.getEffectiveActivities();
  }

  getEffectiveActivities = async () => {
    const productId = tools.getQueryString('productId');
    // const productId = 'FFDBB01036AD4713A9A045501B197391'
    try {
      const result = await getEffectiveActivities(productId);
      if (result) {
        if (result.status === 2) {
          this.setState({ isActive: true });
        }
      }
    } catch (e) {
      // console.log(e);
    }
  }

  loadFormData = async () => {
    const productId = tools.getQueryString('productId');

    try {
      const { code, data, message } = await getFormInfo(productId);

      if (code !== 10000) return Toast.show(message || '获取表单错误');

      this.setState({ formData: data });
    } catch (e) {
      Toast.show(e.message || '获取表单错误');
    }
    return true;
  }

  handleSubmitForm = () => {
    const { formData, detailObj } = this.state;
    const haveNotInput = formData.find((item) => {
      const { isMust, fieldId } = item;
      // eslint-disable-next-line react/destructuring-assignment
      const value = this.state[fieldId];
      if (isMust && !value) return true;
      return false;
    });

    if (haveNotInput) return Toast.show(`${haveNotInput.fieldName}为必填`, 0.8);
    const form = [];
    formData.forEach((item1) => {
      const item = item1;
      const { fieldId } = item;
      // eslint-disable-next-line react/destructuring-assignment
      let value = this.state[fieldId];
      if (Array.isArray(value)) value = value.join(',');
      item.value = value;
      form.push(JSON.stringify(item));
    });

    const productId = tools.getQueryString('productId');
    const shareUserId = tools.getQueryString('shareUserId');
    const { formId } = detailObj;
    const data = {
      customerInfo: form,
      productId,
      shareUserId,
      formId,
    };

    saveFormInfo(data).then(() => {
      Toast.show('提交成功');
      const formObj = {};
      formData.forEach((item) => {
        const { fieldId } = item;
        formObj[fieldId] = '';
      });

      this.setState({
        // ...this.state,
        ...formObj,
      });
    });
    return false;
  }

  handleChangeInput = (key) => (event) => {
    const { value } = event.target;
    this.setState({
      [key]: value,
    });
  }

  handleRadioChange = (key, value) => (event) => {
    const { checked } = event.target;
    let radioValue = value;
    if (checked) radioValue = null;

    this.setState({ [key]: radioValue });
  }

  handleCheckboxSelect = (key, value) => (event) => {
    const { checked } = event.target;
    const checkboxValue = [];

    if (!checked) {
      checkboxValue.push(value);
    } else {
      // eslint-disable-next-line react/destructuring-assignment
      const targetIndex = this.state[key].indexOf(value);
      checkboxValue.splice(targetIndex, 1);
    }
    this.setState({
      [key]: checkboxValue,
    });
  }

  handleChangeTime = (key) => (value) => this.setState({ [key]: format(new Date(value), 'y-MM-dd') })

  detailProductData() {
    const productId = tools.getQueryString('productId');
    const shareUserId = tools.getQueryString('shareUserId');
    getProductDetails(`?productId=${productId}&shareUserId=${shareUserId}`).then((res) => {
      if (res.code === 10000) {
        this.setState({
          detailObj: res.data,
        });
      }
    });
  }

  renderForm = () => {
    const { formData, detailObj } = this.state;

    if (!formData || (Array.isArray(formData) && !formData.length)) return null;

    return (
      <div ref={this.formBox} className={styles.form} id="form_submit">
        <div className={styles.header}>
          <span>{detailObj.templateType === 1 ? '预约咨询' : '咨询报备'}</span>
          <div className={styles.downButton}>
            <img src={downImage} alt="downImage" />
          </div>
        </div>
        <div>
          {this.renderFormItem()}
          <Button className={styles.submitButton} onClick={this.handleSubmitForm}>
            提交
          </Button>
        </div>
      </div>
    );
  }

  /**
   * 返回表单条目
   * fieldType  number 必须 字段类型 0文本 1数值 2单选 3多选 4时间
   * @returns {any[]}
   */
  renderFormItem = () => {
    const { formData } = this.state;
    return formData.map((item) => {
      const {
        fieldName, fieldId, isMust, fieldType, customFieldOptionModels,
      } = item;
      // eslint-disable-next-line react/destructuring-assignment
      const value = this.state[fieldId];
      const placeholder = isMust ? `必填，请输入${fieldName}` : `请输入${fieldName}`;

      let element = null;
      switch (fieldType) {
        case 0:
        case 5:
          element = (
            <div className={styles.panelItem} key={fieldId}>
              <div className={styles.time}>
                {!!isMust && <span className={styles.red}>*</span>}
                {fieldName}
                :
              </div>
              <input type="text" placeholder={placeholder} value={value} onChange={this.handleChangeInput(fieldId)} />
            </div>
          );
          break;
        case 1:
          element = (
            <div className={styles.panelItem} key={fieldId}>
              <div className={styles.time}>
                {!!isMust && <span className={styles.red}>*</span>}
                {fieldName}
                :
              </div>
              <input
                type="number"
                placeholder={placeholder}
                value={value}
                onChange={this.handleChangeInput(fieldId)}
              />
            </div>
          );
          break;

        case 2:
          element = (
            <div className={styles.panelItem} key={fieldId}>
              <div className={styles.label}>
                {!!isMust && <span className={styles.red}>*</span>}
                {fieldName}
                :
              </div>
              <div className={styles.formRight}>
                {customFieldOptionModels.map((item1) => {
                  const { optionName, id } = item1;
                  return (
                    <Checkbox
                      className={styles.radioCheckbox}
                      onClick={this.handleRadioChange(fieldId, optionName)}
                      checked={value === optionName}
                      key={id}
                    >
                      {optionName}
                    </Checkbox>
                  );
                })}
              </div>
            </div>
          );
          break;

        case 3:
          element = (
            <div className={classNames(styles.panelItem, 'formCheckbox')} key={fieldId}>
              <span className={styles.label}>
                {!!isMust && <span className={styles.red}>*</span>}
                {fieldName}
                :
              </span>
              <div className={styles.formRight}>
                {customFieldOptionModels.map((item2) => {
                  const { optionName, id } = item2;
                  return (
                    <Checkbox
                      className={styles.radioCheckbox}
                      onClick={this.handleCheckboxSelect(fieldId, optionName)}
                      checked={value ? value.includes(optionName) : false}
                      key={id}
                    >
                      {optionName}
                    </Checkbox>
                  );
                })}
              </div>
            </div>
          );
          break;
        case 4:
        default:
          element = (
            <div className={styles.panelItem} key={fieldId}>
              <span className={styles.time}>
                {!!isMust && <span className={styles.red}>*</span>}
                {fieldName}
                :
              </span>
              <DatePicker
                mode="date"
                title="选择日期"
                extra="选择日期"
                value={value ? new Date(value) : undefined}
                onChange={this.handleChangeTime(fieldId)}
              >
                <span className={styles.placeholder}>
                  {value ? (
                    format(new Date(value), 'y-MM-dd')
                  ) : (
                    <input type="text" readOnly placeholder="选择日期" />
                  )}
                </span>
              </DatePicker>
            </div>
          );
          break;
      }
      return element;
    });
  }

  render() {
    const { detailObj, formData, isActive } = this.state;
    const showFormIcon = Array.isArray(formData)
     && formData.length > 0
     && detailObj.templateType !== 2;

    // 判断是否是开户
    const isOpenAccount = detailObj.templateType === 4;
    return (
      <div className={styles.container}>
        <CarouselComponent carouselArray={detailObj.productImg} />
        <MainInfoComponent mainInfoObj={detailObj} />
        <div className={styles.placeholderLine} />
        <DescHtml descHtml={detailObj.introduction} />
        <img width="100%" src={detailObj.tradingImg} alt="" />
        {detailObj.templateType && !isOpenAccount && detailObj.templateType !== 2 && (
          <>
            <div className={styles.placeholderLine} />
            {this.renderForm()}
          </>
        )}

        {isActive ? (
          <Activity productName={detailObj.name} productImg={detailObj.productImg[0]} />
        ) : (
          <div />
          // <WXShare
          //   title={this.state.detailObj.name}
          //   imgUrl={this.state.detailObj.productDetailsImg}
          //   desc={this.state.detailObj.highlight}
          // />
        )}

        <BuyButton
          productObj={detailObj}
          isOpenAccount={isOpenAccount}
          showFormIcon={showFormIcon}
          isActive={isActive}
          productImg={detailObj.productImg[0]}
        />
      </div>
    );
  }
}
